import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors, Layouts } from '../../../styles/styles';

const {
	typography: { fontSizes },
	spacing,
	colors,
	common,
} = THEME;

export const styleSheet = StyleSheet.create({
	accountWideCallout: {
		backgroundColor: colors.info.light,
		borderRadius: common.borderRadius,
		color: colors.info.contrastText,
		fontSize: fontSizes.sm,
		lineHeight: 1.4,
		marginBottom: spacing.sm,
		maxWidth: 800,
		padding: spacing.md,
	},
	autoReplySubSetting: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		marginLeft: spacing.xl,
		maxWidth: 320,
	},
	cautionHelpIcon: {
		marginLeft: spacing.sm,
	},
	cautionOption: {
		cursor: 'pointer',
		...CssSelectors.allDescendants({ cursor: 'pointer' }),
	},
	cautionText: {
		...Layouts.horizontalStack(spacing.xs),
		display: 'inline-flex',
		fontSize: fontSizes.sm,
	},
	group: {
		...Layouts.verticalStack(spacing.md),
	},
	label: {
		color: colors.text.light,
		fontSize: fontSizes.sm,
	},
	sectionTitle: {
		color: colors.text.dark,
		fontSize: fontSizes.lg,
		margin: 0,
		marginBottom: spacing.md,
	},
	starRating: {
		...Layouts.horizontalStack(spacing.xs),
		fontSize: fontSizes.lg,
	},
});
